import { superagent } from '../../shared/superagent/superagent';
import singletons from '../../shared/singletons'
import { Observable } from 'rxjs'

class CityBranchesApi {
  choose(cb_id) {
    singletons['loading'].start()
    return Observable.create((obs)=> {
      superagent.put("/api/city_branch")
        .send({city_branch_id: cb_id})
        .end((err, resp)=> {
          // singletons['loading'].stop()
          obs.next(resp.body)
          obs.complete()
        })
    })
  }
}

const cityBranchesApi = new CityBranchesApi()


export { cityBranchesApi }



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/profile/city_branches/city_branches_api.js